import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import { RecentChat, RecentChatList } from "../../types/chat";

const GATEWAY_URL = config.servers.gateway.url;

interface ChatApi {
  chatUrl(workgroupId: string): Promise<string>;
  chatRecent(workgroupId: string): Promise<RecentChat>;
  chatRecentAllWorkgroup(size?: number): Promise<RecentChatList[]>;
  getAccessToken(): Promise<string>;
}

class ChatServerApi implements ChatApi {
  async chatUrl(workgroupId: string): Promise<string> {
    const resp = await axios.get<string>(
      `${GATEWAY_URL}/wapi/chat/url/${workgroupId}?beforeAt=0`
    );

    return Promise.resolve(resp.data);
  }

  async chatRecent(workgroupId: string): Promise<RecentChat> {
    const resp = await axios.get<RecentChat>(
      `${GATEWAY_URL}/wapi/chat/recent/${workgroupId}`
    );

    return Promise.resolve(resp.data);
  }
  async chatRecentAllWorkgroup(size?: number): Promise<RecentChatList[]> {
    const resp = await axios.get<RecentChatList[]>(
      `${GATEWAY_URL}/wapi/chat/recent/list?size=${size}`
    );

    return Promise.resolve(resp.data);
  }

  async getAccessToken(): Promise<string> {
    const resp = await axios.get<string>(`${GATEWAY_URL}/wapi/chat/accesToken`);

    return Promise.resolve(resp.data);
  }
}

const chatAPI: ChatApi = new ChatServerApi();
export default chatAPI;
